// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loading_loader__SIvl_","absolute":"Loading_absolute__2I1Vq","top":"Loading_top__1zi7L"};